<h3-toggle-button-group
  [ngModel]="viewMode$ | async"
  (ngModelChange)="setViewMode($event, { source: 'button' })"
  [buttons]="buttons$ | async"
>
</h3-toggle-button-group>
<h3-button-with-popover popoverTitle="View Settings">
  <ng-container projection-location="button">
    <fa-icon [icon]="faSlidersH"></fa-icon>
    <fa-icon [icon]="faCaretDown"></fa-icon>
  </ng-container>
  <div h3ScrollDisabler projection-location="popover-content">
    <ng-content></ng-content>
  </div>
</h3-button-with-popover>
